<template>
  <div
    class="exhibit"
    :style="{color: roomColor}"
  >
    <div
      class="flexWrapper"
      @click="this.activate"
    >
      <div
        class="number"
        :class="{'invert' : invert}"
        :style="{borderColor: roomColor}"
      >
      <!--div class="pie"> THE GOOD STUFF
        <svg width="100" height="100" ersion="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <path :d="progressPie"></path>
        </svg>
      </div-->
      <div class="numBg">
        {{ this.exhibit.number }}
      </div>
      </div>
      <div class="exhibitContent">
        <div
          class="progressBar"
          :style="styleExhibitProgress"
        ></div>
        <p>{{ this.exhibit.description }}</p>
      </div>
    </div>
    <div
      v-if="hasEntryText"
      class="additionalContent"
      :class="{'show' : this.showContent}"
    >
      <div class="additionalText">
        <p>{{ this.exhibit.intro }}</p>
      </div>
      <div
        class="flexWrapper"
        @click="this.openExhibit"
      >
        <div class="btnPlay">
          <PlaySVG />
        </div>
        <div class="btnText">
          <PlaySVG /> Beitrag Abspielen
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PlaySVG from '../../public/svg/play.svg';

export default {
  components: {
    PlaySVG,
  },
  data() {
    return {
      exhibitFinished: false,
      exhibitProgress: 0,
      showContent: false,
    };
  },
  props: {
    exhibit: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    roomColor: {
      type: String,
      required: true,
    },
    invert: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.invert = this.$helper.isBrightHSL(this.roomColor);

    const numberSplit = this.exhibit.number.split('/');
    if (numberSplit.length > 1) {
      this.exhibit.number = `${numberSplit[0]}
      &
      ${numberSplit[1]}`;
    }
  },
  computed: {
    ...mapGetters(['currentFloor', 'currentRoom', 'currentExhibit', 'playerActive', 'backgroundPattern']),
    isActiveExhibit() {
      return (this.currentExhibit !== null
        ? this.currentExhibit.uid === this.exhibit.uid
        : false);
    },
    styleExhibitProgress() {
      return {
        width: `${(this.exhibitFinished ? 100 : this.exhibit.progress)}%`,
        // backgroundImage: this.backgroundPattern,
      };
    },
    hasEntryText() {
      return this.exhibit.intro !== undefined;
    },
    progressPie() {
      return this.calcPie(this.exhibitFinished ? 100 : this.exhibit.progress);
    },
  },
  watch: {
    playerActive(newValue) {
      if (!newValue) {
        this.showContent = false;
      }
    },
  },
  methods: {
    ...mapActions(['setExhibit', 'setPlayerActive']),
    activate() {
      if (this.hasEntryText) {
        this.toggleContent();
      } else {
        this.openExhibit();
      }
    },
    toggleContent() {
      if (this.showContent) {
        this.showContent = false;
        // this.setExhibit(null);
      } else {
        this.showContent = true;
        // this.setExhibit(this.exhibit);
      }
    },
    openExhibit() {
      // if (!this.isActiveExhibit && this.currentExhibit === null) {
      this.setExhibit(this.exhibit);
      this.setPlayerActive(true);
      this.$router.push({ name: 'Exhibit', params: { exhibitId: this.exhibit.id } });
      if (process.env.VUE_APP_DEBUG === 'on') console.log(' from exhibit');
      // }
    },
    calcPie(progress) {
      const a = progress * 3.6;
      const angle = (a - 90) * (Math.PI / 180);
      const x = 50 + 50 * Math.cos(angle);
      const y = 50 + 50 * Math.sin(angle);
      return `M50,50 L50,0 ${progress >= 50 ? 'A50,50 1 0,1 50,100' : ''} A50,50 1 0,1 ${x},${y} z`;
    },
  },
};
</script>

<style scoped lang="scss">
.exhibit{
  display: block;
  color: var(--main-text-color);
  min-height: 60px;

  .flexWrapper {
    display: flex;
  }
  &.active {
    position: relative;
  }
  p {
    color: var(--main-text-color);
    /* font-size: .9em; */
    margin: 0;
  }
  .number {
    border: solid 2px grey;
    border-color: inherit;
    background-color: var(--main-background-color);
    color: var(--main-text-color);
    color: inherit;
    box-sizing: border-box;
    width: 30px;  // UGLY SHIT
    min-height: 60px;  // UGLY SHIT
    font-size: 1em;  // UGLY SHIT
    margin-bottom: 2em;
    font-weight: bold;

    display: flex; // UGLY SHIT
    justify-content: center; // UGLY SHIT
    align-items: center; // UGLY SHIT

    /* The good stuff
    width: 30px;
    height: 30px;
    min-height: 30px;
    border-radius: 15px;
    font-size: .9em;
    margin: 0 5px;

    .pie {
      position: absolute;
      width: 26px;
      height: 26px;
      border-radius: 13px;
      overflow:hidden;

       svg {
         margin: -4px 0 0 -4px;
         width: 34px;
         height: 34px;
         fill: var(--main-elements-color);
       }
    }*/
    .numBg {
      text-align: center;
      /* The good stuff
      position: absolute;
      width: 18px;
      height: 18px;
      border-radius: 9px;
      margin: 4px;
      background-color: var(--main-background-color);

      display: flex;
      justify-content: center;
      align-items: center; */
    }
  }
  .exhibitContent {
    position: relative;
    /* padding-bottom: 30px; */
    /* padding-bottom: 2vh;
    padding-bottom: calc(var(--vh, 1vh) * 2); */
    padding-bottom: 2em;
    color: var(--main-text-color);
    flex: 1;

    .progressBar {
      position: absolute;
      top: 0;
      width: 0;
      height: calc(100% - 30px);
      background-size: 50px;
      background-color: var(--main-disabled-color);
      z-index: -999;

      &.finished {
        width: 100%;
      }
    }
    p {
      padding: 5px 12px 8px 12px;
    }
  }
  @media (prefers-color-scheme: light) {
    .number {
      &.invert {
        color: var(--main-text-color);
      }
    }
  }
  @media (prefers-color-scheme: dark) {
    .number {
      &.invert {
        color: inherit;
      }
    }
  }
}
.additionalContent {
  position: relative;
  top:-15px;
  display: none;

  &.show {
    display: block;
  }

  .additionalText {
    margin-bottom: 15px;

    p {
      padding: 0;
      /* The good Stuff
      padding-left: 52px; */
      padding-left: 42px; // UGLY SHIT
    }
  }

  .btnPlay {
    width: 30px; // UGLY SHIT
    /* min-height: 60px;
    border: solid 2px #999;
    border-color: var(--main-elements-color);
    background-color: var(--main-background-color);
    color: var(--main-elements-color);
    box-sizing: border-box;
    font-size: 1.2em;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px; */

    svg {
      width: 30px;
      height: 30px;
      fill: var(--main-elements-color);
      display: none;
    }
  }
  .btnText {
    padding: 8px 12px;
    flex: 1;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    color: var(--main-elements-color);
    font-size: 1.2em;
    /* text-transform: uppercase; */
    margin-bottom: 10px;
    /* font-weight: bold; */

    svg {
      width: 1.3em;
      height: 1.3em;
      fill: var(--main-elements-color);
      margin-right: .4em;
      display: inline;
    }
  }
}
@media only screen and (orientation : portrait) and (max-height : 600px) {
  .exhibit{
    font-size: .85em;
  }
}
</style>
